import styled from 'styled-components';
import { THEME } from '../../../../../../themes';
import { ReactComponent as HEART } from '../../../../../../assets/heart.svg';

export const HeartIcon = styled(HEART)`
  color: ${THEME.COLORS.ACCENT};
  width: 17.3px;
  height: 16px;
`;
